export const AI_TUTOR_LEGACY_LABS = ['applab', 'gamelab', 'weblab'];

export const PROJECT_EXAMPLES: Record<string, string[]> = {
  applab: [
    `[Choose Your Adventure](https://studio.code.org/projects/applab/nI9iumSHbTn5mHBXl-wxMw/view)`,
    `[Landmark Flashcards](https://studio.code.org/projects/applab/sNZOTB_PiXAHt3Q5h_aRgQ/view)`,
    `[Pensive Painter](https://studio.code.org/projects/applab/IAK_Qyc23QrkAB61KGvn1g/view)`,
    `[Pet Poll](https://studio.code.org/projects/applab/TjHfwdUd3ENlyImb7VX5Cg/view')})`,
    `[Poke the Pig](https://studio.code.org/projects/applab/r469vc1FFSOxOlUruTFlUA/view)`,
    `[Slider Sketch](https://studio.code.org/projects/applab/JNbplBXMisx2aMefUkh39g/view)`,
  ],
  gamelab: [
    `[Bounce](https://studio.code.org/projects/gamelab/J2R-PHcvE4Wgb2xO2bjk0Q/view)`,
    `[Make Your Own Character](https://studio.code.org/projects/gamelab/XVEFITms8-c7_F-ND-FKL8w3A-oEpFD_GKAJCB2VPCQ/view)`,
    `[Sunset Shapes](https://studio.code.org/projects/gamelab/Z9QRSmJBfNY25T3ViLp0MTy4uAuXNNXpZrmhPsUdEro/view)`,
  ],
  weblab: [
    `[Catering website](https://studio.code.org/projects/weblab/Z3m2fWClc10iTgxiLnOfTqZHApYrFXgx8YqgCwAvXvs/view)`,
    `[Photo Gallery](https://studio.code.org/projects/weblab/kkb1upGQja7Hy4NAa72uQxwu87jDa_DO1aiav2Qhzk8/view)`,
  ],
};
